<div id="thisisaMobileAppScrewWidescreen">
  <app-personal-banner></app-personal-banner>
  <app-link-tile-grid></app-link-tile-grid>
</div>
